import { InputHTMLAttributes, Ref, TextareaHTMLAttributes } from 'react';
import './EpInput.scss';
import { EpInput } from './EpInput';
import { EpTextarea } from './EpTextarea';

interface EpInputComponentProps {
  inputId: string;
  inputType?: string;
  inputName: string;
  inputValue?: string;
  inputAutocomplete?: 'on' | 'off';
  inputAriaDescribedby?: string;
  inputSize: 'sm' | 'md' | 'lg';
  inputMaxValue?: number;
  inputMinValue?: number;
  inputMaxLength?: number;
  inputMinLength?: number;
  inputWidth?: number;
  inputAddonLeftText?: string;
  inputAddonRightText?: string;
  inputIsFullWidth?: boolean;
  inputIsDisabled?: boolean;
  inputWithError?: boolean;
  inputPlaceholder?: string;
  inputHasIcon?: boolean;
  inputIconName?: string;
  customClasses?: string;
}

export interface EpInputProps
  extends EpInputComponentProps,
    InputHTMLAttributes<HTMLInputElement> {
  inputOnChangeFunc?: (arg?: unknown) => void;
  inputOnFocusFunc?: (event: React.FocusEvent<HTMLInputElement>) => void;
  ref?: Ref<HTMLInputElement>;
}

export interface EpTextareaProps
  extends EpInputComponentProps,
    TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: Ref<HTMLTextAreaElement>;
}

export const setIconSize = (inputSize: string): number => {
  let iconSize: number;

  switch (inputSize) {
  case 'sm':
    iconSize = 14;
    break;
  case 'md':
    iconSize = 16;
    break;
  case 'lg':
    iconSize = 20;
    break;
  default:
    iconSize = 16;
  }

  return iconSize;
};

export const setTelephoneInputInitialValue = async (
  inputId: string,
  number: number | string,
) => {
  const phoneInputField = document.querySelector(`#${inputId}`) as
    | HTMLElement
    | HTMLInputElement;
  const inputType = phoneInputField.getAttribute('type');

  if (inputType !== 'tel') return;

  const phoneInputInstance =
    window.intlTelInputGlobals.getInstance(phoneInputField);

  phoneInputInstance.setNumber(number.toString());
};

export { EpInput, EpTextarea };
